import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import SectionGate from '../../../app/SectionGate';
import { AdminDispatch } from '../../../app/store';
import { initialize, selectAppSettingsState } from './appSlice';

const useInitialize = () => {
  const dispatch = useDispatch<AdminDispatch>();
  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);
};

// Init gate for the settings section. Acts as a route layout: the
// section's page lives in the consolidated route table (app/Main.tsx) and
// renders through the <Outlet /> that SectionGate provides once initialized.
const App = () => {
  const { initialized, initializing, initError } = useSelector(
    selectAppSettingsState,
  );
  useInitialize();

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!initError}
      wrapper={AppInnerWrapper}
    />
  );
};

export default App;
